import { createI18nConfig } from '@/app/utils';

export const AUTO_CLOSE_AFTER = 15; // undo tip 自动关闭的时间，单位秒

export const NONE_LABEL = createI18nConfig<string>({ en: 'None', ja: 'なし' }, '无');

export const HD_LABEL = createI18nConfig<string>(
  {
    en: ', HD',
    ja: '、HD',
  },
  '，高清',
);

export const SPLIT_LABEL = createI18nConfig<string>(
  {
    en: ', ',
    ja: '、',
  },
  '，',
);

export const TIPS_TEXT = createI18nConfig<string[]>(
  {
    en: [
      'Environment field: Describe ambient/environmental details (e.g., a river beside a coastal castle)',
      'Required categories: Style, Motion Level',
      'Freely inputtable categories: Subject, Environment',
      'Customizable categories: Shot Size, Composition, Camera Movement, Style, Special Filming Technique',
      'Non-customizable categories: Focal Length, Camera Angle, Motion Level',
      'Required categories: Subject, Environment, Style, Motion Level (foundational for video generation)',
      'Best practice: Select 1 option per category for 「Shot Size, Composition, Special Filming, Camera Angle, Focal Length」',
      'Best practice: 2 Camera Movements per video are ideal',
      'Best practice: 1–3 Style descriptions per video achieve ideal outcomes',
    ],
    ja: [
      '「サブジェクト」エリアには、人・物・環境などの見た目、動き、感情などの描写を記入してください',
      '「環境」エリアには、周囲の雰囲気や背景に関する描写を記入してください（例：海辺の城のそばにある草原）',
      '必須項目：スタイル、動きの振れ幅',
      '自由入力可能な項目：サブジェクト、環境',
      '自由入力はできないがカスタム追加は可能な項目：ショットサイズ、構図、カメラワーク、スタイル、特殊な撮影技法',
      '現在カスタム追加ができない項目：焦点距離、カメラアングル、動きの振れ幅',
      '必須項目：主体、環境、スタイル、動きの振れ幅（これらは動画生成の基本となる要素です）',
      'おすすめ：1つの動画につき、「ショットサイズ、構図、特殊な撮影技法、カメラアングル、焦点距離」は各カテゴリ1つずつ選ぶのが最適です',
      'おすすめ：1つの動画に2種類の「カメラワーク」を入れると効果的です',
      'おすすめ：1つの動画に1〜3種類の「スタイル」記述が最適です',
    ],
    de: [
      'Umgebungsfeld: Beschreibe die Umgebungsdetails (z. B. ein Fluss neben einer Küstenburg)',
      'Erforderliche Kategorien: Stil, Bewegungsintensität',
      'Frei ausfüllbare Kategorien: Subjekt, Umgebung',
      'Anpassbare Kategorien: Bildgröße, Komposition, Kamerabewegung, Stil, Besondere Aufnahmetechnik',
      'Nicht anpassbare Kategorien: Brennweite, Kameraperspektive, Bewegungsintensität',
      'Erforderliche Kategorien: Subjekt, Umgebung, Stil, Bewegungsintensität (Grundlage für die Videogenerierung)',
      'Empfohlene Vorgehensweise 1: Wähle pro Kategorie jeweils eine Option bei: Bildgröße, Komposition, Besondere Aufnahmetechnik, Kameraperspektive, Brennweite',
      'Empfohlene Vorgehensweise 2: Ideal: 2 Kamerabewegungen pro Video',
      'Empfohlene Vorgehensweise 3: Optimal: 1–3 Stilbeschreibungen pro Video',
    ],
    ko: [
      '환경 필드: 주변/환경적 요소를 묘사하세요(예: 해안 성곽 옆의 강가)',
      '필수 항목: 스타일, 모션 강도',
      '자유 입력 가능 항목: 주제, 환경',
      '사용자 지정 가능 항목: 샷 크기, 구도, 카메라 무빙, 스타일, 특수 촬영 기법',
      '사용자 지정 불가 항목: 초점 거리, 카메라 앵글, 모션 강도',
      '필수 항목: 주제, 환경, 스타일, 모션 강도(비디오 생성을 위한 기본 요소)',
      '최적 가이드: [샷 크기, 구도, 특수 촬영 기법, 카메라 앵글, 초점 거리]는 항목당 1개의 옵션을 선택합니다.',
      '최적 가이드: 비디오당 카메라 무빙은 2개 선택이 이상적입니다.',
      '최적 가이드: 스타일 설명은 비디오당 1~3개가 이상적입니다.',
    ],
    pt: [
      'Campo de ambiente: Descreva detalhes do ambiente (ex: um rio ao lado de um castelo costeiro)',
      'Categorias obrigatórias: Estilo, Nível de Movimento',
      'Categorias de entrada livre: Sujeito, Ambiente',
      'Categorias personalizáveis: Tamanho do Plano, Composição, Movimento de Câmera, Estilo, Técnica Especial de Filmagem',
      'Categorias não personalizáveis: Distância Focal, Ângulo de Câmera, Nível de Movimento',
      'Categorias obrigatórias: Sujeito, Ambiente, Estilo, Nível de Movimento (fundamentais para a geração de vídeo)',
      'Melhor prática: Selecionar 1 opção por categoria para 「Tamanho do Plano, Composição, Filmagem Especial, Ângulo de Câmera, Distância Focal」',
      'Melhor prática: 2 Movimentos de Câmera por vídeo são ideais',
      'Melhor prática: 1 a 3 descrições de Estilo por vídeo alcançam resultados ideais',
    ],
    ru: [
      'Поле окружения: опишите детали окружающей среды (например, река рядом с прибрежным замком)',
      'Обязательные категории: стиль, уровень движения',
      'Свободно вводимые категории: субъект, окружающая среда',
      'Настраиваемые категории: размер кадра, композиция, движение камеры, стиль, специальная техника съемки',
      'Не настраиваемые категории: фокусное расстояние, угол съемки, уровень движения',
      'Обязательные категории: субъект, окружающая среда, стиль, уровень движения (основополагающие для создания видео)',
      'Рекомендация: выберите 1 вариант для каждой категории: размер кадра, композиция, специальная съемка, угол съемки, фокусное расстояние',
      'Рекомендация: идеально подойдут 2 вида движения камеры на видео',
      'Рекомендация: для достижения идеальных результатов используйте 1–3 описания стиля для каждого видео',
    ],
    fr: [
      'Détails environnementaux  : Décrivez les éléments ambiants/environnementaux (par ex. : une rivière près d’un château côtier)',
      'Catégories requises : Style, niveau de mouvement',
      'Catégories à saisie libre : Sujet, environnement',
      'Catégories personnalisables : Taille de plan, composition, mouvement de la caméra, style, technique de tournage spéciale',
      'Catégories non personnalisables : Distance focale, angle de caméra, niveau de mouvement',
      'Catégories requises : Sujet, environnement, style, niveau de mouvement (fondations essentielles pour la génération vidéo)',
      'Bonne pratique : Sélectionner 1 option par catégorie pour « Taille de plan, composition, technique de tournage spéciale, angle de caméra, distance focale »',
      'Bonne pratique : 2 mouvements de la caméra par vidéo sont idéaux',
      'Bonne pratique : 1 à 3 descriptions de style par vidéo offrent un rendu optimal',
    ],
    es: [
      'Campo de entorno: Describa detalles ambientales o del entorno (ej., un río junto a un castillo costero)',
      'Categorías obligatorias: Estilo, Nivel de movimiento',
      'Categorías de entrada libre: Sujeto, Entorno',
      'Categorías personalizables: Tamaño de la toma, Composición, Movimiento de cámara, Estilo, Técnica de filmación especial',
      'Categorías no personalizables: Distancia focal, Ángulo de cámara, Nivel de movimiento',
      'Categorías obligatorias: Sujeto, Entorno, Estilo, Nivel de movimiento (fundamentales para la generación de vídeo)',
      'Mejor práctica: Seleccione 1 opción por categoría para «Tamaño de la toma, Composición, Filmación especial, Ángulo de cámara, Distancia focal»',
      'Mejor práctica: 2 movimientos de cámara por vídeo es lo ideal',
      'Mejor práctica: De 1 a 3 descripciones de estilo por vídeo logran resultados óptimos,',
    ],
  },
  [
    '「主体」区域建议填写人/物/环境等外观、动作、情绪等描述',
    '「环境」区域建议填写环境、背景相关等氛围描述，比如海边的城堡旁边的草地',
    '必选内容包括：风格、运动幅度',
    '可以自由输入的类型有：主体、环境',
    '不可以自由输入但可以自定义新增内容的有：景别shot size、构图composition、运镜camera movement、风格style、Special filming technique 特殊拍摄技术',
    '暂不支持自定义新增的：焦距Focal length、视角Camera angle、motion level',
    '必填内容包括：主体、环境、风格、运动幅度，必填内容是视频生成内容的基础',
    '最佳实践建议：每个视频中，「景别、构图、特殊拍摄、视角、焦距」这些分类下，分别选择1种即可，不宜过多',
    '最佳实践建议：每个视频有2种「运镜」效果目前效果最佳',
    '最佳实践建议：每个视频中有1-3种「风格」描述效果最佳',
  ],
);
